export enum SaveStatus {
  Idle = "idle",
  Saving = "saving",
  Saved = "saved",
}

export interface State {
  originalValue: string;
  currentValue: string;
  saveStatus: SaveStatus;
  error: string | null;
}

export type Action =
  | { type: "SET_VALUE"; value: string; error: string | null }
  | { type: "START_SAVING" }
  | { type: "SAVE_SUCCESS"; value: string }
  | { type: "SAVE_ERROR"; error: string }
  | { type: "CANCEL" };
